import React from 'react';
import { UnifiedHeader } from './UnifiedHeader';
import { useMode, ModeType } from '../contexts/ModeContext';
import { useSpace } from '../contexts/SpaceContext';
import '../styles/components/professionalTab.css';

interface ProfessionalTabProps {
  isActive: boolean;
  onTabChange?: (tab: 'home' | 'inventory' | 'groups' | 'profile' | 'market') => void;
  onFontSizeToggle: () => void;
  fontSize: string;
  activeMode: ModeType;
  onOpenAppContext: () => void;
}

const ProfessionalTab: React.FC<ProfessionalTabProps> = ({
  isActive,
  onTabChange,
  onFontSizeToggle,
  fontSize,
  activeMode,
  onOpenAppContext
}) => {
  const { activeSpace } = useSpace();
  return (
    <>
      {isActive && (
        <UnifiedHeader
          title="Professional"
          subtitle="Moving Co. & Tools"
          showCollectionDropdown={false}
          showFontSizeToggle={true}
          onFontSizeToggle={onFontSizeToggle}
          fontSize={fontSize}
          activeMode={activeMode}
          onOpenAppContext={onOpenAppContext}
          activeSpaceName={activeSpace?.name}
        />
      )}
      {isActive && (
      <div className="professional-tab-container">
        <div className="professional-hero">
          <div className="professional-hero-icon">🚚</div>
          <h2 className="professional-hero-title">Moving Company</h2>
          <p className="professional-hero-desc">
            Professional tools for managing moves, client inventories, and collection transfers.
          </p>
        </div>

        <div className="professional-features">
          <div className="professional-feature-card" onClick={() => onTabChange?.('inventory')}>
            <div className="professional-feature-icon">📦</div>
            <div className="professional-feature-body">
              <div className="professional-feature-title">Client Inventory</div>
              <div className="professional-feature-desc">Scan and catalogue client items for a move</div>
            </div>
            <div className="professional-feature-arrow">
              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          <div className="professional-feature-card professional-feature-card--coming-soon">
            <div className="professional-feature-icon">📋</div>
            <div className="professional-feature-body">
              <div className="professional-feature-title">Move Checklists</div>
              <div className="professional-feature-desc">Track packing progress room by room</div>
            </div>
            <div className="professional-feature-badge">Coming Soon</div>
          </div>

          <div className="professional-feature-card professional-feature-card--coming-soon">
            <div className="professional-feature-icon">🔗</div>
            <div className="professional-feature-body">
              <div className="professional-feature-title">Collection Transfers</div>
              <div className="professional-feature-desc">Transfer inventories to clients after a move</div>
            </div>
            <div className="professional-feature-badge">Coming Soon</div>
          </div>

          <div className="professional-feature-card professional-feature-card--coming-soon">
            <div className="professional-feature-icon">📊</div>
            <div className="professional-feature-body">
              <div className="professional-feature-title">Move Reports</div>
              <div className="professional-feature-desc">Generate itemised reports for clients</div>
            </div>
            <div className="professional-feature-badge">Coming Soon</div>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default ProfessionalTab;
